/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
/* eslint no-use-before-define:0, prefer-const:0, no-shadow:0, eqeqeq:0, no-var:0 */

let rpc;
const AJAXRPC = require('./ajax-rpc');
const ApiError = require('app/scripts/network/api-error');
const Auth = require('app/scripts/db/auth');
const Backbone = require('app/scripts/lib/backbone');
const Batcher = require('app/scripts/network/rpc/batcher');
const Promise = require('bluebird');
const Socket = require('app/scripts/network/socket');
const SocketRPC = require('./socket-rpc');
const { Storage } = require('@trello/storage');
const Util = require('app/scripts/lib/util');
const _ = require('underscore');
const log = require('app/scripts/debug/log');
const { track } = require('@trello/analytics');
const { memberTokenIsCurrent } = require('./member-token-is-current');

window.dropTheHammer = function() {
  Storage.set('useWebsockets', 'yes');
  return __guardMethod__(console, 'log', (o) =>
    o.log(
      'Websockets engaged! Reload the page, please. Use pitStop() to turn sockets off.',
    ),
  );
};

window.pitStop = function() {
  Storage.set('useWebsockets', 'no');
  return __guardMethod__(console, 'log', (o) =>
    o.log(
      'Shutting Websockets down! Reload the page, please. Use dropTheHammer() to turn sockets back on.',
    ),
  );
};

const VERIFY_INTERVAL_MS = 20 * 1000;

// We want to immediately open up an rpc channel, so we use AJAX until the socket has connected
// and proven that it can answer a ping. If the socket connects and answers quickly, we use
// that for all future requests. If not, we just close it down and keep using AJAX. We defer
// setting up anything that will require polling on the AJAX rpc until we either confirm or
// give up on the socket rpc.
class RPC {
  static initClass() {
    _.extend(this.prototype, Backbone.Events);
  }

  constructor() {
    this.rpcSocket = this.rpcAJAX = this.rpcCurrent = null;
    this.currentSubscriptions = {};

    this.rpcConnectTime = 0;
    this.socketRetryWaitTime = 0;

    // Always start an RPC if we're logged in, so we can get our notifications
    this.handleLogin();

    setTimeout(() => {
      return this.verifySubscriptions();
    }, VERIFY_INTERVAL_MS);
  }

  rpcReady() {
    if (!this.isUsingSocket()) {
      this.rpcCurrent.poll();
    }

    this.trigger('ready');

    this.resubscribe();

    this.listenTo(this, 'reconnect', async () => {
      // Check that the user still has a valid session. Users forcibly
      // logged out via sockets won't have their cookie cleared.
      const validToken = await memberTokenIsCurrent();
      if (!validToken) {
        window.location.reload();
        return;
      }

      this.resubscribe();
    });
  }

  resubscribe() {
    this.rpcCurrent.resync();

    return (() => {
      const result = [];
      for (let idModel in this.currentSubscriptions) {
        const subscription = this.currentSubscriptions[idModel];
        result.push(
          this.subscribe(subscription.modelType, idModel, subscription.tags),
        );
      }
      return result;
    })();
  }

  setActiveRPC(rpc) {
    this.stopListening(this.rpcCurrent);
    this.rpcCurrent = rpc;

    this.listenTo(this.rpcCurrent, 'all', (...args) => {
      return this.trigger(...Array.from(args || []));
    });
  }

  lazyCreateRPC() {
    if (
      this.isUsingSocket() ||
      Util.getTime() - this.rpcConnectTime < this.socketRetryWaitTime
    ) {
      return;
    }

    this.rpcConnectTime = Util.getTime();
    this.socketRetryWaitTime = Util.randomWait(
      Util.getMs({ minutes: 20 }),
      Util.getMs({ minutes: 10 }),
    );

    // Create a new socket instance to force new Socket creation
    this.rpcSocket = new SocketRPC(this);
    if (this.rpcAJAX != null) {
      this.rpcAJAX.stopPolling();
    } else {
      this.rpcAJAX = new AJAXRPC(this);
    }

    // Until the socket proves it works, you're on AJAX rpc.
    this.setActiveRPC(this.rpcAJAX);

    if (this.rpcSocket.hasSocketTransport()) {
      // Sockets have a chance of working. They have 8s to answer a ping before we give up on 'em.
      const msPingWait = 8000;

      return this.rpcSocket.ping((err, result, pingedSocket) => {
        const pingElapsedTime = Util.getTime() - this.rpcConnectTime;
        if (err != null || pingElapsedTime > msPingWait) {
          // Socket took too long. Use AJAX.
          log('rpc', 'Socket not responsive. Using AJAX.');

          // by the time we get here, @rpcCurrent may already be pointing at
          // a different socket than the one we just pinged
          pingedSocket.disconnect();
          pingedSocket.destroy();

          this.rpcSocket = null;

          if (err) {
            track(
              'RPC',
              'No Sockets',
              'Failed ping',
              'Error message',
              err.message,
            );
          } else {
            track('RPC', 'No Sockets', 'Slow ping', pingElapsedTime);
          }
          this.rpcReady();
          setTimeout(() => {
            return this.lazyCreateRPC();
          }, this.socketRetryWaitTime);
        } else {
          // Yay, we have sockets!
          log(
            'rpc',
            'Socket responded to ping in a timely fashion. Using sockets.',
          );
          this.setActiveRPC(this.rpcSocket);
          this.rpcReady();
        }
      });
    } else {
      // We do not have an acceptable socket transport. Use AJAX.
      log('rpc', 'No socket connect. Using AJAX.');
      track('RPC', 'No Sockets', 'Unsupported');
      return this.rpcReady();
    }
  }

  handleLogin() {
    if (Auth.isLoggedIn()) {
      return this.lazyCreateRPC();
    }
  }

  unsubscribe(modelType, idModel) {
    this.lazyCreateRPC();
    this.rpcCurrent.unsubscribe(modelType, idModel);
    return delete this.currentSubscriptions[idModel];
  }

  _subscribeOrHandle(modelType, idModel, tags) {
    return Promise.fromNode((next) => {
      return this.rpcCurrent.subscribe(modelType, idModel, tags, next);
    }).catch((err) => {
      if (err.message === 'unauthorized') {
        this.handleInvalidSubscription(idModel);
        return this.trigger(
          'subscription_unauthorized',
          modelType,
          idModel,
          tags,
        );
      }
    });
  }

  subscribe(modelType, idModel, tags) {
    let subscription;
    this.lazyCreateRPC();

    if ((subscription = this.currentSubscriptions[idModel]) != null) {
      subscription.tags = _.union(subscription.tags, tags);
    } else {
      this.currentSubscriptions[idModel] = {
        tags,
        ixLastUpdate: -1,
        modelType,
        idModel,
      };
    }

    return this._subscribeOrHandle(modelType, idModel, tags);
  }

  getIxLastUpdate(idModel) {
    return this.currentSubscriptions[idModel] != null
      ? this.currentSubscriptions[idModel].ixLastUpdate
      : undefined;
  }

  setIxLastUpdate(idModel, ixLastUpdate) {
    let entry;
    if ((entry = this.currentSubscriptions[idModel]) != null) {
      return (entry.ixLastUpdate = ixLastUpdate);
    }
  }

  resync(...idModels) {
    this.lazyCreateRPC();
    return typeof this.rpcCurrent.resync === 'function'
      ? this.rpcCurrent.resync(...Array.from(idModels || []))
      : undefined;
  }

  isUsingSocket() {
    return this.rpcCurrent != null && this.rpcCurrent === this.rpcSocket;
  }

  handleInvalidSubscription(idModelInvalid) {
    let subscription;
    if ((subscription = this.currentSubscriptions[idModelInvalid]) != null) {
      const { modelType, idModel, tags } = subscription;

      this.unsubscribe(modelType, idModel);
      this.trigger('invalidModel', modelType, idModel, tags);
    }
  }

  _verificationUrls() {
    const subscriptions = Object.values(this.currentSubscriptions);

    const me = Auth.isLoggedIn() ? Auth.me() : null;

    return subscriptions
      .map(function({ modelType, idModel }) {
        const url = (() => {
          switch (modelType) {
            case 'Board':
              var idBoards = me && me.get('idBoards');
              if (idBoards && Array.from(idBoards).includes(idModel)) {
                // If it's in our idBoards we're allowed to see it
                return null;
              } else {
                return `/boards/${idModel}/name`;
              }
            case 'Member':
              if (idModel === Auth.myId()) {
                // Don't bother checking if we can read our member channel
                return null;
              } else {
                return `/members/${idModel}/fullName`;
              }
            case 'Organization':
              var idOrganizations = me && me.get('idOrganizations');
              if (
                idOrganizations &&
                Array.from(idOrganizations).includes(idModel)
              ) {
                // If it's in our idOrganizations we know we're allowed to see it
                return null;
              } else {
                return `/organizations/${idModel}/displayName`;
              }
            default:
              return null;
          }
        })();

        if (url) {
          return { id: idModel, url };
        }
      })
      .filter((entry) => entry != null);
  }

  _sendVerificationRequests() {
    const verifyData = this._verificationUrls();

    if (verifyData.length === 0) {
      return Promise.resolve();
    }

    const batcher = new Batcher();

    verifyData.forEach(({ id, url }) => {
      return batcher.request(url).catch(ApiError, () => {
        return this.handleInvalidSubscription(id);
      });
    });

    return batcher.send();
  }

  // This is meant to catch some tricky situations where we might have lost
  // access to something even though we received no websocket update informing
  // us.  For example, a public board or team that we're looking at may have
  // been deleted, or a team visible board that we aren't a member of might
  // have been changed to private.
  verifySubscriptions() {
    clearTimeout(this._verifyTimeout);

    return this._sendVerificationRequests()
      .finally(() => {
        let timeout;
        return (timeout = this._verifyTimeout = setTimeout(() => {
          if (timeout === this._verifyTimeout) {
            return requestAnimationFrame(() => {
              return this.verifySubscriptions();
            });
          }
        }, VERIFY_INTERVAL_MS));
      })
      .done();
  }
}
RPC.initClass();

module.exports = rpc = window.rpc = new RPC();

// If we're unable to subscribe to our own member channel, something
// has gone wrong (possibly we deleted our account or our session was
// invalidated from another browser)
if (Auth.isLoggedIn()) {
  rpc.on('invalidModel', function(typeName, id) {
    if (typeName === 'Member' && Auth.isMe(id)) {
      return Auth.removeToken();
    }
  });
}

function __guardMethod__(obj, methodName, transform) {
  if (
    typeof obj !== 'undefined' &&
    obj !== null &&
    typeof obj[methodName] === 'function'
  ) {
    return transform(obj, methodName);
  } else {
    return undefined;
  }
}
